import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  reviewBoxContainer: {
    minHeight: '700px',
    maxHeight: '700px',
    overflowY: 'auto',
    position: 'relative',
  },
}))
